import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Maps from '../../../store/map';

function SearchBar(props) {
    const handleChanged = (e) => {
        props.lsportsActions.prematch.search(e.target.value);
    };

    const openSeachBar = () => {};

    let { search } = props.lSports.prematch;

    return (
        <div className="sport-header pt-2 disable-select">
            <div className="sports-box-row" style={{ height: '40px' }}>
                <div className="sport-search-bar show-search pb-2">
                    <input
                        type="text"
                        className="ml-2 form-control search-bar"
                        autoFocus
                        placeholder="Search here"
                        value={search ? search : ''}
                        onChange={handleChanged}
                    />
                    <Link className="search-close-btn" to="/prematch">
                        <i className="material-icons" onClick={openSeachBar}>
                            close
                        </i>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default connect(Maps.mapLSportsStateToProps, Maps.mapLSportsDispatchToProps)(SearchBar);
